import {useCallback, useState} from "react";

export const useGeneratePdf = ({
  pdfDocumentName,
  pdfUrl,
  hasScrollEnforcementFeatureFlag,
}: {
  pdfDocumentName: string;
  pdfUrl: string | null;
  hasScrollEnforcementFeatureFlag: boolean;
}) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const generatePdf = useCallback(async () => {
    if (!hasScrollEnforcementFeatureFlag || isGenerating || !pdfUrl) return;

    setIsGenerating(true);
    try {
      const response = await fetch(pdfUrl);

      if (!response.ok) {
        throw new Error("Failed to fetch PDF");
      }

      const blob = await response.blob();
      const file = new File([blob], pdfDocumentName, {type: "application/pdf"});

      setFile(file);
    } catch (error) {
      setFile(null);
    } finally {
      setIsGenerating(false);
    }
  }, [pdfUrl, pdfDocumentName, isGenerating, hasScrollEnforcementFeatureFlag]);

  return {
    isGenerating,
    file,
    generatePdf,
  };
};

export const downloadPdf = (file: File, pdfDocumentName: string) => {
  if (!file) return; // Prevent download if no file or already downloading

  const url = window.URL.createObjectURL(file as File);
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = pdfDocumentName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  window.URL.revokeObjectURL(url);
};
